import React, {useRef, useState} from 'react';
import enumList from 'web/utils/enumList';
const {caseFlgStatus} = enumList;

/**
 * @param {React.PropsWithChildren}
 * @return {React.ReactNode}
 */
export default function EnableSwitch({
  disabled,
  flgStatus,
  onChange,
  trueConditionValue,
  falseConditionValue,
  children,
}) {
  trueConditionValue = trueConditionValue || caseFlgStatus.open;
  falseConditionValue = falseConditionValue || caseFlgStatus.close;
  const inputRef = useRef(null);
  const [isChanging, setIsChanging] = useState(false);
  const [isChecked, toggleIsChecked] =
    useState(flgStatus === trueConditionValue);
  const FLG_STATUS_LIST = [falseConditionValue, trueConditionValue];

  /**
   *
   * @param {InputEvent} e
   */
  const handleChange = async (e) => {
    setIsChanging(true);
    try {
      e.nextValue = FLG_STATUS_LIST[+e.target.checked];
      await onChange(e);
      toggleIsChecked(!e.target.checked);
    } catch (error) {
      toggleIsChecked(e.target.checked);
      throw error;
    } finally {
      setIsChanging(false);
    }
  };

  const focusToInput = () => {
    inputRef.current.focus();
  };

  return <div className="form-check form-switch">
    <input
      ref={inputRef}
      className="form-check-input"
      type="checkbox"
      role="switch"
      checked={isChecked}
      disabled={disabled || isChanging}
      onChange={handleChange}
    />
    <label className="form-check-label" onClick={focusToInput}>
      {children}
    </label>
  </div>;
};
